import React from 'react';

export const getPointNameCartError = (name: string) => {
  return (
    <div>
      {name + ' is already in the shopping cart.'}
      <div></div>
      {'Please rename the point or remove it from the cart.'}
    </div>
  );
};
